export const detectMobileWidth = () => window.innerWidth < 700;

export const isMobile = detectMobileWidth();